// utils/sessionHandler.js
class SessionHandler {
  static isHandlingExpiration = false;

  static handleSessionExpiration() {
    // Prevent multiple simultaneous redirects
    if (this.isHandlingExpiration) return;
    this.isHandlingExpiration = true;

    // Clear authentication data
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('userRole');
    localStorage.removeItem('authToken');
    
    // Show user-friendly message
    alert('Your session has expired. Please login again.');
    
    // Redirect to login
    window.location.href = '/login';
    
    // Reset flag after a delay
    setTimeout(() => {
      this.isHandlingExpiration = false;
    }, 1000);
  }

  static setupGlobalErrorHandler() {
    // Override the global fetch function
    const originalFetch = window.fetch;
    
    window.fetch = async (...args) => {
      try {
        const response = await originalFetch(...args);
        
        // Check if response is not ok and handle session expiration
        if (!response.ok) {
          const clonedResponse = response.clone();
          try {
            const errorData = await clonedResponse.json();
            
            // Check for session expiration error
            if (errorData.error === "Session expired, please login again" || 
                response.status === 401) {
              this.handleSessionExpiration();
              return response; // Return the original response
            }
          } catch (jsonError) {
            // If response is not JSON, continue with original response
          }
        }
        
        return response;
      } catch (error) {
        // Handle network errors
        throw error;
      }
    };
  }
}

// Initialize the session handler when the module loads
SessionHandler.setupGlobalErrorHandler();

export default SessionHandler;